import { render, staticRenderFns } from "./client-bind-transport-vehicle-info-group-modal.vue?vue&type=template&id=3cd75c34&"
import script from "./client-bind-transport-vehicle-info-group-modal.vue?vue&type=script&lang=js&"
export * from "./client-bind-transport-vehicle-info-group-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports